import { get, set, cloneDeep } from "lodash";

import { tabsName } from "./const";

export const initialState = {
  invoiceData: null,
  selectedElements: [],
  selectedSection: "",
  activeTab: tabsName.general,
  templateConfigBackup: null,
  templateConfigBackup: null,
  invoiceForm: "Electronic",
};

export function reducer(state, action) {
  switch (action.type) {
    case "switchTab": {
      return { ...state, activeTab: action.payload.tab };
    }

    case "switchInvoiceForm": {
      return { ...state, invoiceForm: action.payload };
    }

    case "selectSection": {
      return {
        ...state,
        selectedSection: action.payload.selected ? action.payload.section : "",
      };
    }

    case "selectElement": {
      let selectedElements = [...state.selectedElements];
      const element = selectedElements.find(e => e.id === action.payload.id);
      if (element) {
        selectedElements = selectedElements.filter(
          e => e.id !== action.payload.id
        );
      } else {
        selectedElements.push(action.payload);
      }

      return { ...state, selectedElements };
    }

    case "deselectElements": {
      return { ...state, selectedElements: [] };
    }

    case "updateStyleForSelectedElement": {
      const invoiceData = cloneDeep(state.invoiceData);
      const selectedElements = state.selectedElements;

      selectedElements.forEach(element => {
        const currentValue = get(invoiceData, element.stylePath);
        set(invoiceData, element.stylePath, {
          ...currentValue,
          ...action.payload.style,
        });
      });

      return { ...state, invoiceData };
    }

    case "updateInvoiceData": {
      const invoiceData = cloneDeep(state.invoiceData);
      const currentValue = get(invoiceData, action.payload.path);
      if (Array.isArray(currentValue)) {
        set(invoiceData, action.payload.path, action.payload.value);
      } else if (typeof currentValue === "object") {
        set(invoiceData, action.payload.path, {
          ...currentValue,
          ...action.payload.value,
        });
      } else {
        set(invoiceData, action.payload.path, action.payload.value);
      }
      return { ...state, invoiceData };
    }

    case "updateInvoiceDataDnD": {
      const invoiceData = cloneDeep(state.invoiceData);
      set(invoiceData, action.payload.path, action.payload.value);

      return { ...state, invoiceData };
    }

    case "loadInvoiceTemplateConfig": {
      return {
        ...state,
        invoiceData: action.payload.templateConfig,
        templateConfigBackup: cloneDeep(action.payload.templateConfig),
      };
    }

    case "resetInvoiceTemplateConfig": {
      return {
        ...state,
        invoiceData: cloneDeep(state.templateConfigBackup),
      };
    }

    case "extractWatermarkImageSize": {
      return { ...state, watermarkImageSize: action.payload };
    }

    default:
      return initialState;
  }
}
